import React from 'react'
import Service from './Service'
import Title from './Title'
const Services = () => {
  return (
    <div className="container-fluid  container overflow-scroll w-auto">
      <Title title='Our Services' />
    <Service />
    </div>
     
  )   
     
}

export default Services